import React from "react";

import { Tab } from "@headlessui/react";

import scrollToEl from "common/action-function/scrollToElement";
import { formatDate } from "common/functions";

import ButtonNew from "components/atoms/ButtonNew";
import CheckContent from "components/atoms/CheckContent";
import { BsClock } from "components/atoms/Icon/bs/BsClock";
import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import Banner from "components/organisms/Banner";
import FormDownload from "components/organisms/FormDowload";
import { WhatMakeUsDifferentV3 } from "components/organisms/WhatMakeUsDifferent/WhatMakeUsDifferentV3";

const HongKongEcommerceGuide = ({ data, posts }) => {
  const firstPost = posts[0] || {};
  const listPost =
    posts.length > 1
      ? posts.filter((item, index) => index > 0 && index < 6)
      : [];

  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-569"
        title={
          <h1
            className="mb-4 text-center text-bbc-40px font-semibold text-bbc-brand-600 lg:mb-2 lg:text-left lg:text-bbc-48px"
            dangerouslySetInnerHTML={{ __html: data.banner.title }}
          />
        }
        description={
          <div
            className="mb-4 text-center lg:mb-6 lg:text-left"
            dangerouslySetInnerHTML={{ __html: data.banner.description }}
          />
        }
        tag={data.banner.tag}
        breadcrumbs={data.banner.breadcrumbs}
        breadcrumbMarginClass={"mb-6"}
        bgColor={"bg-bbc-gradient-hk-ecommerce"}
        titleProps={{
          textColor: "text-bbc-brand-600",
        }}
        rightClassName="lg:col-5"
        rightContent={
          <Img
            wrapper={{
              className: "bbc-banner-image-country xl:top-24",
            }}
            src={data.banner.image}
            width={540}
            height={459}
            priority={true}
            alt="banner-img"
          />
        }
        leftClassName="relative col-12 lg:col-7"
        leftContent={
          <div className="mb-6 text-center lg:mb-0 lg:pb-10 lg:text-left xl:pb-0">
            <ButtonNew
              href={`#${data.dataFormDownload.id}`}
              as="a"
              className=""
              onClick={(e) => {
                scrollToEl(e, false);
              }}
            >
              Download now
            </ButtonNew>
          </div>
        }
      />
      <section className="mt-10 lg:mt-20">
        <div className="container">
          <Title
            text="With this guide, you'll be able to"
            className="title-h2 mb-6 text-center text-bbc-brand-700 lg:mb-10"
          />
          <div className="hidden lg:block">
            <div className="row">
              <div className="col-12 lg:col-6">
                <Img
                  width={540}
                  height={540}
                  alt="section-1-image"
                  {...data.ebookImage}
                />
              </div>
              <div className="col-12 lg:col-6">
                <Tab.Group as="div" className="mt-6">
                  <Tab.List className="flex gap-x-4">
                    {data.dataWhatMakeUsDifferent.map((item, index) => (
                      <Tab key={index} className="relative mb-6">
                        {({ selected }) => (
                          <span
                            className={`inline-block px-1 py-2 text-lg font-medium ${
                              selected
                                ? "text-bbc-brand-600 before:absolute before:bottom-0 before:left-0 before:h-0.5 before:w-full before:bg-bbc-brand-600 before:content-['']"
                                : "text-bbc-neutral-600"
                            }`}
                          >
                            {item.title}
                          </span>
                        )}
                      </Tab>
                    ))}
                  </Tab.List>
                  <Tab.Panels>
                    {data.dataWhatMakeUsDifferent.map((item, index) => (
                      <Tab.Panel key={index}>
                        {item.description.map((element, i) => (
                          <React.Fragment key={i}>
                            {element.content && (
                              <p className="mb-2 font-medium">{element.text}</p>
                            )}
                            {element.listWithIcon && (
                              <ul className="pl-2">
                                {element.listWithIcon.map((e, number) => (
                                  <li key={number} className="mb-2">
                                    <CheckContent data={e} />
                                  </li>
                                ))}
                              </ul>
                            )}
                          </React.Fragment>
                        ))}
                      </Tab.Panel>
                    ))}
                  </Tab.Panels>
                </Tab.Group>
              </div>
            </div>
          </div>
          <WhatMakeUsDifferentV3
            data={data.dataWhatMakeUsDifferent}
            ebookImage={data.ebookImage}
            className="lg:hidden"
          />
        </div>
      </section>
      <section>
        <div className="container">
          <Title
            text="Browse the latest insights"
            className="title-h2 mb-6 text-center text-bbc-brand-700"
          />
          <p className="mb-6 text-center lg:mb-10">
            Get the facts you need on various topics of Hong Kong E-commerce to
            make the right decisions.
          </p>
          <div className="row">
            <div className="col-12 lg:col-8">
              <div className="overflow-hidden rounded-[20px] bg-bbc-neutral-200 hover:shadow-[0px_0px_20px_rgba(124,120,120,0.2)]">
                <Img image={firstPost?.featuredImage?.node} />
                <div className="p-6 lg:px-10 lg:pb-10 lg:pt-8">
                  <Title
                    as="h3"
                    className="text-lg font-semibold text-bbc-brand-900 lg:text-bbc-30px"
                  >
                    <Link href={firstPost?.uri}>{firstPost?.title}</Link>
                  </Title>
                  <div className="mt-6 inline-flex items-center">
                    <BsClock size={18} />
                    <span className="inline-block pl-2 text-sm">
                      {formatDate(firstPost?.date)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 lg:col-4">
              <div className="row mt-6 gap-y-3 lg:mt-0">
                {listPost.map((item, index) => (
                  <div className="col-12" key={index}>
                    <div className="p-2">
                      <Title
                        as="h3"
                        className="text-lg font-medium line-clamp-3"
                      >
                        <Link href={item?.uri}>{item?.title}</Link>
                      </Title>
                      <div className="mt-3 inline-flex items-center">
                        <BsClock size={18} />
                        <span className="inline-block pl-2 text-sm">
                          {formatDate(item?.date)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id={data.dataFormDownload.id}
        className="bg-bbc-gradient-service py-10 lg:py-20"
      >
        <div className="container">
          <FormDownload
            title={data.dataFormDownload.title || ""}
            description={data.dataFormDownload.description || ""}
            checkboxText={data.dataFormDownload.checkboxText || ""}
            checkboxTextClassName={
              data.dataFormDownload.checkboxTextClassName || ""
            }
            apiLink={data.dataFormDownload.form.apiLink}
            checkedId={data.dataFormDownload.form.checkedId}
            unCheckId={data.dataFormDownload.form.unCheckId}
            countryId={data.dataFormDownload.form.countryId}
          />
        </div>
      </section>
    </>
  );
};

export default HongKongEcommerceGuide;
